import { useModuleConfig } from '@rebuild/hooks/data/useModuleConfig';

const prepareQuestionTabs = (tabList = []) => {
	return tabList
		.filter(item => item?.isPublish)
		.map(item => ({
			...item,
			label: item.name
		}));
};

export const useQuestionConfigData = () => {
	const { config, loadModuleConfig } = useModuleConfig();

	const loadQuestionTabs = async () => {
		await loadModuleConfig('question');
		return prepareQuestionTabs(config.value?.tab || []);
	};

	return {
		config,
		loadQuestionTabs
	};
};
